import styled from "styled-components";

import { Color, ColorV2, Text } from "@adoptaunabuelo/react-components";
import { Star } from "lucide-react";
import media from "styled-media-query";

const Container = styled.li`
	display: flex;
	flex: 1;
	flex-direction: column;
	border: 1px solid ${Color.line.soft};
	border-radius: 12px;
	padding: 24px;
	min-height: 312px;
	max-height: 312px;
	box-sizing: border-box;
	${media.lessThan("medium")`
		max-width: 100%;
		min-width: calc(100vw - 82px);
		padding: 20px 16px;
	`}
`;
const Row = styled.div`
	display: flex;
	flex-direction: row;
`;
const Col = styled.div`
	display: flex;
	flex-direction: column;
`;
const Image = styled.img`
	height: 48px;
	width: 48px;
	border-radius: 100px;
	background-color: ${Color.background.soft};
`;
const TestimonyText = styled(Text)`
	display: -webkit-box;
	-webkit-line-clamp: 8;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	margin: 0 !important;
	line-height: 22px !important;
	max-height: 176px;
`;

const TestimonyCell = (props: Props) => {
	return (
		<Container
			style={{
				maxWidth: `${100 / props.nCells}%`,
			}}
		>
			<Row style={{ alignItems: "center", marginBottom: 12 }}>
				<Col style={{ flex: 1}}>
					<Text type="p" weight="medium">
						{props.testimony.name}
					</Text>
					{props.testimony.date && (
						<Text
							type="c1"
							style={{ color: ColorV2.text.neutralMedium }}
						>
							{props.testimony.date}
						</Text>
					)}
				</Col>
				<Image src={props.testimony.image} />
			</Row>
			<Row style={{ marginBottom: 8 }}>
				<Star
					height={20}
					width={20}
					color={ColorV2.surface.secondary}
					fill={ColorV2.surface.secondary}
				/>
				<Star
					height={20}
					width={20}
					color={ColorV2.surface.secondary}
					fill={ColorV2.surface.secondary}
				/>
				<Star
					height={20}
					width={20}
					color={ColorV2.surface.secondary}
					fill={ColorV2.surface.secondary}
				/>
				<Star
					height={20}
					width={20}
					color={ColorV2.surface.secondary}
					fill={ColorV2.surface.secondary}
				/>
				<Star
					height={20}
					width={20}
					color={ColorV2.surface.secondary}
					fill={ColorV2.surface.secondary}
				/>
			</Row>
			<TestimonyText type="p2">{props.testimony.testimony}</TestimonyText>
		</Container>
	);
};
export default TestimonyCell;
export interface Props {
	nCells: number;
	testimony: {
		name: string;
		image: any;
		testimony: string;
		date?: string;
	};
}
